export function emailOtpLit(list) {
    return {
        type: "EMAIL_OTP_LIST",
        list
    };
}
